import React from 'react';
import { Icon } from '@blueprintjs/core';

import Abbr from './Abbr';
import Na from './Na';

const isValidURL = str => {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(str);
};

export const RenderValue = ({ value }) => {
  if (typeof value === 'string' || typeof value === 'number') {
    if (isValidURL(value)) {
      return (
        <a href={value} target="_blank" rel="noreferrer">{value}</a>
      );
    }

    return value;
  }

  if (typeof value === 'boolean') {
    return value
      ? <Abbr short={<Icon icon="tick" />} long="Oui" />
      : <Abbr short={<Icon icon="cross" />} long="Non" />;
  }

  if (typeof value === 'undefined') {
    return <Na />;
  }

  if (value === null) {
    return <Na />;
    // return (<tt>null</tt>);
  }

  if (typeof value === 'object') {
    return <pre>{JSON.stringify(value, null, 2)}</pre>;
  }

  return null;
};

export default RenderValue;
